import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-44325237")

_pushScopeId("data-v-44325237")
const _hoisted_1 = { class: "flex items-center" }
const _hoisted_2 = {
  key: 0,
  class: "relative"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")

  return (_openBlock(), _createBlock("label", _hoisted_1, [
    _createVNode("span", {
      class: `text-13 ${_ctx.labelClasses}`
    }, _toDisplayString(_ctx.label), 3),
    (_ctx.tooltip)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode(_component_font_awesome_icon, {
            class: `ml-2 text-icon-secondary cursor-pointer ${_ctx.tooltipIconClasses}`,
            icon: "info-circle",
            onMouseover: _cache[1] || (_cache[1] = ($event: any) => (_ctx.tooltipVisible = true)),
            onMouseout: _cache[2] || (_cache[2] = ($event: any) => (_ctx.tooltipVisible = false))
          }, null, 8, ["class"]),
          (_ctx.tooltipVisible)
            ? (_openBlock(), _createBlock("div", {
                key: 0,
                class: [
            `tooltip tooltip-${_ctx.tooltipPosition} absolute bg-dark text-white p-2 w-36 font-normal rounded text-center
              text-10 z-50`,
            _ctx.tooltipPosition === 'right' && 'left-10',
            _ctx.tooltipPosition === 'left' && 'right-10',
            _ctx.tooltipPosition === 'bottom' && 'top-7',
            _ctx.tooltipPosition === 'top' && 'bottom-7'
          ]
              }, _toDisplayString(_ctx.tooltip), 3))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
})